import React from 'react';
import { Box } from '@mui/material';
import { PRES } from '../chrome';
import ThumbnailFrame from './ThumbnailFrame';

interface AssetThumbnailProps {
  src?: string;
  alt?: string;
  fit?: 'cover' | 'contain';
  selected?: boolean;
  onClick?: () => void;
  onDoubleClick?: () => void;
}

const AssetThumbnail: React.FC<AssetThumbnailProps> = ({
  src,
  alt = '',
  fit = 'cover',
  selected,
  onClick,
  onDoubleClick,
}) => (
  <ThumbnailFrame
    ratio="1 / 1"
    selected={selected}
    onClick={onClick}
    onDoubleClick={onDoubleClick}
  >
    {src ? (
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: fit,
          display: 'block',
          bgcolor: fit === 'contain' ? PRES.surfaceSunken : PRES.surface,
        }}
      />
    ) : (
      <Box sx={{ width: '100%', height: '100%', bgcolor: PRES.surfaceSunken }} />
    )}
  </ThumbnailFrame>
);

export default AssetThumbnail;
